import React from 'react';

export type FlagSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

interface FlagProps {
  /** ISO alpha-2 (or a flag-icons subdivision code). Null renders nothing. */
  countryCode: string | null | undefined;
  code?: string;
  size?: FlagSize;
  className?: string;
}

const sizeMap: Record<FlagSize, string> = {
  xs: 'w-4 h-3',
  sm: 'w-5 h-4',
  md: 'w-8 h-6',
  lg: 'w-10 h-7',
  xl: 'w-12 h-9',
};

/**
 * A country flag from the flag-icons stylesheet.
 *
 * Renders NOTHING when it has no usable code. `fi-${code}` for a code the
 * stylesheet does not know (a country name, an alpha-3, an empty string)
 * produces a sized, background-less box - a blank gap that reads as a layout
 * bug. Resolve codes with `utils/jurisdictionFlag` before passing them here.
 */
const Flag: React.FC<FlagProps> = ({ countryCode, code, size = 'md', className = '' }) => {
  const sizeClass = sizeMap[size];

  if (!countryCode) return null;

  return (
    <div
      className={`fi fi-${countryCode.toLowerCase()} ${sizeClass} overflow-hidden flex-shrink-0 shadow-sm ${className}`}
      title={code || countryCode}
    />
  );
};

export default Flag;
